import { FormConfig } from '../types/form'

/**
 * Load form configuration from public folder
 */
export const loadFormConfig = async (): Promise<FormConfig> => {
  try {
    const response = await fetch('/content/beta-form.json')
    if (!response.ok) {
      throw new Error(`Failed to load form config: ${response.status}`)
    }
    return await response.json()
  } catch (error) {
    console.error('Error loading form configuration:', error)
    throw error
  }
}

/**
 * Validate form configuration structure
 */
export const validateFormConfig = (config: any): config is FormConfig => {
  if (!config || typeof config !== 'object') {
    return false
  }

  if (typeof config.title !== 'string' || typeof config.description !== 'string') {
    return false
  }

  if (!Array.isArray(config.fields)) {
    return false
  }

  return config.fields.every((field: any) => {
    return (
      typeof field.question === 'string' &&
      typeof field.key === 'string' &&
      ['string', 'integer', 'array<string>'].includes(field.type) &&
      (field.options === undefined || Array.isArray(field.options))
    )
  })
}

/**
 * Get default form configuration (fallback)
 */
export const getDefaultFormConfig = (): FormConfig => ({
  title: 'Beta Testing Application',
  description: 'Please fill out this form to apply for beta testing.',
  fields: [
    {
      question: 'What\'s your email address?',
      key: 'email',
      type: 'string'
    },
    {
      question: 'What\'s your name?',
      key: 'name',
      type: 'string'
    },
    {
      question: 'Why are you interested in beta testing?',
      key: 'reason',
      type: 'string'
    }
  ]
})
